// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__hzK-L","list":"styles_list__2ZqLx"};